"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const cleanQuery = (query) => (0, lodash_1.mapValues)(query, (a) => {
    if (a === "true")
        return true;
    if (a === "false")
        return false;
    return a;
});
exports.default = cleanQuery;
//# sourceMappingURL=cleanQuery.js.map